const clean = (value) => String(value || '').trim();

const nameParts = (value = {}) => {
  const firstName = clean(value.firstName || value.fName);
  const lastName = clean(value.lastName || value.lName);
  return [firstName, lastName].filter(Boolean).join(' ');
};

/**
 * Meeting labels must use a person's real first + last name whenever those
 * fields are available. `username` remains only a backwards-compatible
 * fallback for old room records and visitor accounts without profile names.
 */
export const getMeetingDisplayName = (person, fallback = 'Participant') => {
  if (!person) return fallback;
  if (typeof person === 'string') return clean(person) || fallback;

  const nestedUser = person.user && typeof person.user === 'object'
    ? person.user
    : {};

  return (
    nameParts(nestedUser) ||
    nameParts(person) ||
    clean(person.displayName) ||
    clean(nestedUser.displayName) ||
    clean(person.name) ||
    clean(nestedUser.name) ||
    clean(person.username) ||
    clean(nestedUser.username) ||
    clean(person.email) ||
    clean(nestedUser.email) ||
    fallback
  );
};

export const getMeetingInitial = (person, fallback = '?') =>
  getMeetingDisplayName(person, fallback).charAt(0).toUpperCase() || fallback;

